export default "__VITE_ASSET__6b3d2fb8__"